<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ pageTitle }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <alert
            :title="pageTitle"
            :success-message="$t('common.isSuccess')"
            :error-message="$t('common.isFailure')"
            :alerts="alerts"
            :errors="errors"
            :display="alertDisplay"
            @closeAlert="closeAlert"
          />
          <csv-upload
            :page-name="pageName"
            :format="format"
            @uploaded="uploaded"
          />
          <div
            id="datatable_wrapper"
            class="dataTables_wrapper form-inline dt-bootstrap no-footer"
          >
            <div class="row">
              <div class="col-sm-6">
                <table-length @changeRowPerPage="changeRowPerPageCount" />
              </div>
              <div class="col-sm-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label
                    >{{ $t('common.search') }}:
                    <input
                      v-model="searchString"
                      @keyup="searchWord"
                      type="search"
                      class="form-control input-sm"
                      placeholder=""
                      aria-controls="datatable"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-table
                  :display-items="displayItems"
                  :column-titles="tableHeaderColumns"
                  @sortTable="sortTable"
                />
              </div>
            </div>
            <pagination
              :page-par-item-count="displayItemPerPageCount"
              :total-item-count="totalItemCount"
              :current-page="currentPage"
              @changePage="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import config from '@/config/config'
import CsvRequest from '@/http/CsvRequest'
import { convertLocalDateTime } from '@/utility/time'
import alert from '@/mixin/alert'
import list from '@/mixin/list'

import Alert from '@/components/common/alert/Alert'
import CsvUpload from '@/components/common/csv/CsvUpload'
import Table from '@/components/common/table/Table'
import Pagination from '@/components/tabale/Pagination'
import TableLength from '@/components/tabale/TableLength'

export default {
  components: {
    Alert,
    Pagination,
    TableLength,
    AppTable: Table,
    CsvUpload,
  },
  mixins: [list, alert],
  data() {
    return {
      tableHeaderColumns: [
        this.$t('common.fileName'),
        this.$t('common.status'),
        this.$t('common.uploadDate'),
        this.$t('common.importStartTime'),
        this.$t('common.importEndTime'),
      ],
      fetchedData: [],
    }
  },
  computed: {
    ...mapGetters({
      displayMode: 'menu/getDisplayMode',
    }),
    format() {
      switch (this.$route.name) {
        case 'itemlistUpload':
          return 1
        case 'priceCsvUpload':
          return 3
        case 'recommmendUpload':
          return 4
        case 'shopCsvUpload':
          return 5
        case 'sertchTagCsvUpload':
          return 6
        case 'groupCsvUpload':
          return 7
        case 'menuCsvUpload':
          if (this.displayMode === config.menuStatus.draft) {
            return 9
          } else {
            return 10
          }
        case 'calorieCsvUpload':
          return 11
        default:
          return 0
      }
    },
    pageName() {
      switch (this.$route.name) {
        case 'itemlistUpload':
          return this.$t('subMenu.itemInformation')
        case 'priceCsvUpload':
          return this.$t('orderPage.priceInformation')
        case 'recommmendUpload':
          return this.$t('common.recommend')
        case 'shopCsvUpload':
          return this.$t('operationalManagementPage.shopInformation')
        case 'sertchTagCsvUpload':
          return this.$t('orderPage.searchTagInformation')
        case 'groupCsvUpload':
          return this.$t('operationalManagementPage.shopGroupInformation')
        case 'menuCsvUpload':
          if (this.displayMode === config.menuStatus.draft) {
            return this.$t('orderPage.menuDraft')
          } else {
            return this.$t('orderPage.inOperationMenu')
          }
        case 'calorieCsvUpload':
          return this.$t('orderPage.itemCalorie')
        default:
          return ''
      }
    },
    pageTitle() {
      switch (this.$route.name) {
        case 'itemlistUpload':
          return this.$t('orderPage.itemInformationUpload')
        case 'priceCsvUpload':
          return this.$t('orderPage.priceInformationUpload')
        case 'recommmendUpload':
          return this.$t('adPage.recommendUpload')
        case 'shopCsvUpload':
          return this.$t('operationalManagementPage.shopInformationUpload')
        case 'sertchTagCsvUpload':
          return this.$t('orderPage.searchTagInformationUpload')
        case 'groupCsvUpload':
          return this.$t('operationalManagementPage.shopGroupInformationUpload')
        case 'menuCsvUpload':
          if (this.displayMode === config.menuStatus.draft) {
            return this.$t('orderPage.menuDraft')
          } else {
            return this.$t('orderPage.inOperationMenu')
          }
        case 'calorieCsvUpload':
          return this.$t('orderPage.itemCalorieUpload')
        default:
          return ''
      }
    },
  },
  watch: {
    fetchedData: function(newFetchedData) {
      const data = newFetchedData
      this.fetchItems = data.list.map((item) => {
        let status
        switch (item.status) {
          case 0:
            status = this.$t('commonCsvUpload.processWaiting')
            break
          case 1:
            status = this.$t('commonCsvUpload.processing')
            break
          case 2:
            status = this.$t('commonCsvUpload.imported')
            break
          case 9:
            status = `${this.$t('commonCsvUpload.error')}<br>${
              item.errorDescription
            }`
            break
          default:
            status = item.status
            break
        }

        return [
          item.fileName || '',
          status,
          item.uploadedAt
            ? convertLocalDateTime(item.uploadedAt).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            : '',
          item.importStartedAt
            ? convertLocalDateTime(item.importStartedAt).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            : '',
          item.importFinishedAt
            ? convertLocalDateTime(item.importFinishedAt).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            : '',
        ]
      })
      this.allItems = this.fetchItems
      this.totalItemCount = this.allItems.length
      this.displayItems = this.allItems.slice(0, this.displayItemPerPageCount)
    },
  },
  mounted() {
    const request = new CsvRequest()
    request
      .getHistory(this.format)
      .then((res) => {
        this.fetchedData = res.data
      })
      .catch(() => {
        this.fetchedData = []
      })
  },
  methods: {
    uploaded: function(result, response) {
      if (result) {
        this.fetchedData = response
        this.openSuccessAlert()
      } else {
        this.openErrorAlert(response)
      }
    },
    sortTable: function(newArray) {
      this.displayItems = newArray
    },
  },
}
</script>
